import AppFunction from "../../../../../core/helpers/app/AppFunction.js";

export const TableHelpers = {
  data() {
    return {
      tableColumns: [

        {
            title: this.$t("image"),
            type: "media-object",
            key: "image_url",
            default: AppFunction.getAppUrl('images/default-shipment.jpg'),
            modifier: (value, _) => {
              if (value) {
                return value;
              }
              return "";
            },

            isVisible: true,
          },
          

        {
          title: this.$t("name"),
          type: "text",
          key: "name",
        },



        // {
        //   title: this.$t("category"),
        //   type: "object",
        //   key: "category",
        //   modifier: (value, _) => {
        //     if (value) {
        //       return value["name"];
        //     }
        //     return "";
        //   },
        // },

        {
          title: this.$t("status"),
          type: "custom-html",
          key: "status",
          isVisible: true,
          modifier: (value) => {
            if (value) {
              let ClassName = "danger";

              if (value === "active") ClassName = `success`;
              else if (value === "invited") ClassName = `warning`;

              return `<span class="badge badge-sm badge-pill badge-${ClassName}">${this.$t(
                value
              )}</span>`;
            }
          },
        },
      ],

      actionObj: {
        title: this.$t("action"),
        type: "action",
      },
    };
  },
};
